import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { Cell, TableData, getMultipleSlices } from 'utils/data'
import { isDistrict, isGroup, isRegion, isStore } from 'utils/location'
import { TRANSLATION_KEYS } from '../../locales/translation-keys'

export const PAYROLL_TIME_DIMENSIONS = [
    'prior_month',
    'this_month',
    'next_month',
] as const

export const getTabs = (location: string): string[] => {
    const commonTabs = ['work group', 'overtime']
    return isStore(location)
        ? ['monthly', ...commonTabs]
        : ['location', ...commonTabs]
}
export const getHeaderText = (currentLocation: string) => {
    const { payroll } = TRANSLATION_KEYS
    const { location } = payroll
    if (isStore(currentLocation)) {
        return location.payrollByWeek
    }
    return location.payrollByLocation
}
export const getPayrollPaths = (
    currentLocation: string,
    searchParams: URLSearchParams,
) => {
    const isStoreLocation = isStore(currentLocation)
    const expectedPath = isStoreLocation
        ? '/payroll/monthly'
        : '/payroll/location'
    const fullPath = `${expectedPath}?${searchParams.toString()}`
    const validPaths = ['/payroll/location', '/payroll/monthly']
    return { expectedPath, fullPath, validPaths }
}

export const getFormattedReportDate = (language?: string) => {
    const reportDate = new Date()
    const locale = language?.startsWith('es') ? es : undefined
    return format(reportDate, 'MMM d', { locale })
}
export const getFormattedDateMonthandYear = (
    language?: string,
    date?: Date,
) => {
    const reportDate = date ?? new Date()
    const locale = language?.startsWith('es') ? es : undefined
    return format(reportDate, 'MMM yyyy', { locale })
}
export const getDynamicSubPath = (location: string) => {
    if (isRegion(location)) {
        return `/REGION/${location}`
    } else if (isGroup(location)) {
        return `/GROUP/${location}`
    } else if (isDistrict(location)) {
        return `/DISTRICT/${location}`
    }

    return ''
}
export const getLocationTimePeriodType = (location: string) => {
    if (isStore(location)) {
        return 'weekly'
    }
    return 'monthly'
}
export const getLocationPlannedIndexes = (location: string) => {
    return {
        startIndex: 4,
        endIndex: 7,
    }
}
export const getLocationTableIndexes = (location: string) => {
    if (isStore(location)) {
        return {
            startIndex: 4,
            endIndex: 7,
        }
    }
    return {
        startIndex: 2,
        endIndex: 4,
    }
}
export const getLocationFlexHours = (location: string, footer: Cell[]) => {
    const flexIndexes = getLocationPlannedIndexes(location)
    const flexHours = getMultipleSlices(footer, [
        flexIndexes.startIndex,
        flexIndexes.endIndex,
    ])

    let [projectedFlexHours, trailerFlexHours, adjustmentsHours] = flexHours
    return {
        projectedFlexHours,
        trailerFlexHours,
        adjustmentsHours,
    }
}
export const pickData = (
    currentData: TableData,
    currentLocation: string,
    tableStartIndex: number,
    tableEndIndex: number,
    firstHeader: string,
) => {
    const filteredCopy = { ...currentData }
    const { headings, rows, footer } = currentData
    const sliceParams: (number | [number, number])[] = isStore(currentLocation)
        ? [[tableStartIndex, tableEndIndex]]
        : [[tableStartIndex, tableEndIndex], [1, 2], 6]
    if (headings) {
        filteredCopy.headings = getMultipleSlices(
            headings,
            ...(sliceParams as any),
        )
        filteredCopy.headings.unshift({ value: firstHeader })
    }
    if (rows) {
        filteredCopy.rows = [...rows].map((row) => {
            let pickColumns = null
            if (row[0].childOf) {
                pickColumns = isStore(currentLocation)
                    ? getMultipleSlices(row, [3, 6])
                    : getMultipleSlices(
                          row,
                          [tableStartIndex, tableEndIndex],
                          [1, 2],
                      )
            } else {
                pickColumns = getMultipleSlices(row, ...(sliceParams as any))
            }
            return [row[0], ...pickColumns]
        })
    }
    if (footer) {
        filteredCopy.footer = getMultipleSlices(footer, ...(sliceParams as any))
    }
    return filteredCopy
}
